import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import billableTimeReportComponent from './billable-time-report.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let billableTimeReportModule = angular.module('billabletimereport', [
  uiRouter,
  modal,
  datepickerPopup
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('billabletimereport', {
    parent: 'app',
    url: '/admin/reports/billabletimereport',
    data: {
      pageHeader: true,
      pageTitle: 'Billable Time Report',
      pageDesc: '',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<billabletimereport></billabletimereport>'
  });

})

.component('billabletimereport', billableTimeReportComponent);

export default billableTimeReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/billable-time-report/billable-time-report.js